document.addEventListener('DOMContentLoaded', function() {
  var form = document.getElementById('antaa-search-form');
  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var q = document.getElementById('antaa-search-input').value.trim();
      if (!q) return;
window.location.href = '/search?type=product&options[fields]=title,tag&options[prefix]=last&options[unavailable_products]=hide&q=' + encodeURIComponent(q);
    });
  }
});
// 一点限り表示
document.addEventListener('DOMContentLoaded', function() {
  if (window.location.pathname.includes('/products/')) {
    var addToCartBtn = document.querySelector('[name="add"]');
    if (addToCartBtn) {
      var badge = document.createElement('p');
      badge.textContent = 'この商品は一点ものです';
      badge.style.cssText = 'font-size:13px; color:#888; margin-bottom:8px;';
      addToCartBtn.parentNode.insertBefore(badge, addToCartBtn);
    }
  }
});
